// extracted by mini-css-extract-plugin
export default {"meta":"SeriesHoverCard-module__meta--3PQSK","animatedBackground":"SeriesHoverCard-module__animatedBackground--JfKpQ"};